// Color conversion utilities

const rgbToHex = (r, g, b) => {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  };
  
  const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  };
  
  const rgbToHsl = (r, g, b) => {
    // ... (rest of the function remains the same)
  };
  
  const hslToRgb = (h, s, l) => {
    // ... (rest of the function remains the same)
  };
  
  export const convertColor = (value, fromUnit, toUnit) => {
    const conversions = {
      'RGB to HEX': (val) => {
        const [r, g, b] = val.split(',').map(Number);
        return rgbToHex(r, g, b);
      },
      'HEX to RGB': (val) => {
        const { r, g, b } = hexToRgb(val);
        return `${r},${g},${b}`;
      },
      'RGB to HSL': (val) => {
        const [r, g, b] = val.split(',').map(Number);
        const [h, s, l] = rgbToHsl(r, g, b);
        return `${h},${s},${l}`;
      },
      'HSL to RGB': (val) => {
        const [h, s, l] = val.split(',').map(Number);
        const [r, g, b] = hslToRgb(h, s, l);
        return `${r},${g},${b}`;
      },
      'HEX to HSL': (val) => {
        const { r, g, b } = hexToRgb(val);
        const [h, s, l] = rgbToHsl(r, g, b);
        return `${h},${s},${l}`;
      },
      'HSL to HEX': (val) => {
        const [h, s, l] = val.split(',').map(Number);
        const [r, g, b] = hslToRgb(h, s, l);
        return rgbToHex(r, g, b);
      },
    };
  
    const conversionKey = `${fromUnit} to ${toUnit}`;
    const conversionFunction = conversions[conversionKey];
  
    if (!conversionFunction) {
      throw new Error('Unsupported conversion');
    }
  
    return conversionFunction(value);
  };